// extracted by mini-css-extract-plugin
module.exports = {"palette_light":"services_palette_light__AKUPa","network-item__action-button":"services_network-item__action-button__3o9Oi","palette_dark":"services_palette_dark__3UmdC"};